import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { FileText, AlertTriangle, CheckCircle2, Package, Zap, Lock, Smartphone, Wrench } from 'lucide-react';
export function ValueStack() {
  const items = [{
    title: "Guía Maestra: Protocolo 'Calma en Casa'",
    desc: 'El sistema CVR completo · Capítulos 1 al 7'
  }, {
    title: 'Plan de Acción de 21 Días',
    desc: 'Tu hoja de ruta diaria · Página 45 en adelante'
  }, {
    title: "Checklist 'SOS Rabietas'",
    desc: 'Para consultar en el momento de la crisis · Anexo 1'
  }, {
    title: 'Registro Semanal de Avances',
    desc: 'Para medir tu progreso semana a semana · Anexo 5'
  }];
  return <section className="py-10 md:py-20 px-5 bg-brand-navy text-white" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <FadeIn data-id="element-193">
          <h2 className="font-serif text-3xl md:text-4xl text-center mb-3 leading-snug font-bold" data-id="element-194">
            Todo lo que viene incluido dentro de tu guía por menos de lo que
            cuesta un café:
          </h2>
          <p className="text-slate-400 text-sm md:text-base text-center mb-12" data-id="element-195">
            Acceso inmediato a tu Sistema Digital. Sin esperas. Sin
            instalaciones.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-196">
          <div className="space-y-4 mb-12" data-id="element-197">
            {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 md:p-5 rounded-xl bg-white/5 border border-white/10" data-id="element-198">
                <FileText className="w-6 h-6 text-brand-orange shrink-0 mt-1" data-id="element-199" />
                <div className="flex-grow min-w-0" data-id="element-200">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-201">
                    <h3 className="font-sans font-bold text-base md:text-lg" data-id="element-202">
                      {item.title}
                    </h3>
                    <span className="inline-flex items-center gap-1 bg-brand-orange text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap" data-id="element-203">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-204" />
                      INCLUIDO
                    </span>
                  </div>
                  <p className="text-slate-300 text-sm" data-id="element-205">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="w-full h-px bg-white/20 mb-8" data-id="element-206" />

          <div className="text-center mb-8" data-id="element-207">
            <p className="text-slate-400 text-sm line-through mb-2" data-id="element-208">
              Valor total: $85.00
            </p>
            <div className="font-sans text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-209">
              PRECIO HOY: $7.00
            </div>
            <p className="text-slate-300 text-sm font-medium" data-id="element-210">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          {/* Kit Digital — value reframe */}
          <div className="bg-[#2A3F6B] border-l-4 border-brand-orange rounded-xl p-5 md:p-6 mb-8" data-id="element-211">
            <div className="flex items-start gap-3 mb-4" data-id="element-212">
              <Package className="w-6 h-6 text-brand-orange shrink-0 mt-0.5" data-id="element-213" />
              <div data-id="element-214">
                <p className="font-sans font-bold text-base md:text-lg text-white leading-snug" data-id="element-215">
                  Acceso Instantáneo a tu Kit Digital de Transformación Familiar
                </p>
                <p className="font-sans text-sm text-slate-300 leading-relaxed mt-1" data-id="element-216">
                  Recibe el Sistema Completo CVR optimizado para lectura rápida
                  en móvil, tablet o impresión.
                </p>
              </div>
            </div>

            <ul className="space-y-3 pl-1" data-id="element-217">
              <li className="flex items-start gap-3 text-sm text-slate-200" data-id="element-218">
                <Zap className="w-4 h-4 text-brand-orange shrink-0 mt-0.5" data-id="element-219" />
                <span data-id="element-220">
                  <span className="font-bold text-white" data-id="element-221">
                    Acceso Inmediato:
                  </span>{' '}
                  Sin esperas, empieza la transformación hoy mismo.
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-200" data-id="element-222">
                <Smartphone className="w-4 h-4 text-brand-orange shrink-0 mt-0.5" data-id="element-223" />
                <span data-id="element-224">
                  <span className="font-bold text-white" data-id="element-225">
                    Formato Multidispositivo:
                  </span>{' '}
                  Diseñado para consultar el Checklist SOS en segundos desde tu
                  celular.
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-200" data-id="element-226">
                <Wrench className="w-4 h-4 text-brand-orange shrink-0 mt-0.5" data-id="element-227" />
                <span data-id="element-228">
                  <span className="font-bold text-white" data-id="element-229">
                    Herramientas de Implementación:
                  </span>{' '}
                  No es solo lectura; es un Sistema de Acción con Guías,
                  Checklists y Plan de 21 días.
                </span>
              </li>
            </ul>
          </div>

          {/* Urgency box */}
          <div className="bg-brand-orange rounded-xl p-4 flex items-center justify-center gap-3 mb-8 shadow-lg" data-id="element-230">
            <AlertTriangle className="w-6 h-6 text-white shrink-0" data-id="element-231" />
            <p className="text-white font-bold text-sm md:text-base" data-id="element-232">
              Precio de lanzamiento. Sube a $27 al terminar la fase beta.
            </p>
          </div>

          {/* CTA + micro-text */}
          <CTAButton mainText="SÍ, QUIERO EL KIT DIGITAL CALMA EN CASA" subText="Acceso inmediato al Sistema CVR por solo $7" variant="white" data-id="element-233" />
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-4 text-xs text-slate-400" data-id="element-234">
            <span className="inline-flex items-center gap-1" data-id="element-235">
              <Smartphone className="w-3.5 h-3.5" data-id="element-236" />
              Multidispositivo
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-237">
              <Zap className="w-3.5 h-3.5" data-id="element-238" />
              Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-239">
              <Lock className="w-3.5 h-3.5" data-id="element-240" />
              Procesado por Hotmart
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}